import US from 'assets/images/countriesFlag/US.png';
import CA from 'assets/images/countriesFlag/CA.png';

export const countriesCode = {
  CA: 'CA',
  US: 'US',
};

export const countriesFlags = {
  US,
  CA,
};

export const canadianPhoneNumberAreaCode = [
  204, 226, 236, 249, 250, 289, 306, 343, 365, 403, 416, 418, 431, 437, 438, 450, 506, 514, 519,
  579, 581, 587, 604, 613, 639, 647, 705, 709, 778, 780, 807, 819, 867, 873, 902, 905,
];

export const getFirstThreeDigits = phoneNumber =>
  parseInt(phoneNumber?.replace(/\(|\)/gm, '').substring(0, 3), 10);
